import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalfAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumnWideHalfAdd"><Path d="M2 4V20H12V18H4V13H22V4H2Z" fill="currentColor"/><Path d="M20 15H18V18H15V20H18V23H20V20H23V18H20V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalfAdd;
